import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { UtilsService } from 'src/app/_services/utils.service';
import { environment } from 'src/environments/environment';
import { AlertApiDialog } from '../alert-api-error/alert-api-dialog';
import { AlertDialog } from '../alert-dialog/alert-dialog';

export interface EmpConfigurationDialogData {
  machineId: any;
  data: any[];
}

@Component({
  selector: 'app-emp-configuration-dialog',
  templateUrl: './emp-configuration-dialog.html',
  styleUrls: ['./emp-configuration-dialog.scss'],
})
export class EmpConfigurationDialog implements OnInit {
  confirmButtonColor: string = 'warn';
  dataSource: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<EmpConfigurationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: EmpConfigurationDialogData,
    private httpClient: HttpClient,
    private router: Router,
    private utilsService: UtilsService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    // if (this.data.confirmButtonColor) {
    //   this.confirmButtonColor = this.data.confirmButtonColor;
    // }
    this.dataSource = this.data.data;

    // if (this.data.machineId) {
    //   this.httpClient
    //     .get<any>(`${environment.baseApiUrl}/support/queryEmpConfiguration`, {
    //       headers: {
    //         Version: '2',
    //       },
    //       params: {
    //         machineId: this.data.machineId,
    //       },
    //     })
    //     .pipe(
    //       concatMap((res) => {
    //         if (!res.success) {
    //           //this.errorFlag = true;
    //           //return this.utilsService.showAlert(res.message, res.errors);
    //           this.dialogRef.close();
    //           return this.openAlertDialog(res.message);
    //         }

    //         this.dataSource = res.data.channels;

    //         return of(null);
    //       }),
    //       catchError((err) => {
    //         //this.errorFlag = true;
    //         const defaultMessage =
    //           'Unable to query emp configuration. Maybe connectivity issue?';

    //         const message =
    //           err instanceof HttpErrorResponse
    //             ? defaultMessage
    //             : typeof err === 'object'
    //             ? err.message
    //             : err ?? defaultMessage;

    //         //return this.utilsService.showAlert(message);
    //         return this.openAlertDialog(message);
    //       })
    //     )
    //     .subscribe();
    // }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  openAlertDialog(message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(AlertDialog, {
      disableClose: false,
      data: {
        message: message,
      },
    });

    return dialogRef.afterClosed();
  }

  openAlertApiDialog(message: string, errors: any[]): Observable<boolean> {
    const dialogRef = this.dialog.open(AlertApiDialog, {
      disableClose: false,
      data: {
        message: message,
        errors: errors.map((v) => v.message).join('\n'),
      },
    });

    return dialogRef.afterClosed();
  }
}
